import { CSSProperties, ReactNode, useState, MouseEvent } from 'react'
import { colorPrimario } from '../../styles/colors'
 
export enum ButtonVariants {
	CONFIRM = 'CONFIRM',
	CANCEL = 'CANCEL',
	DELETE = 'DELETE',
	REGULAR = 'REGULAR'
}
interface GralButtonProps {
	onClick?: (e: MouseEvent<HTMLButtonElement>) => void,
	variant?: ButtonVariants,
	width?: string,
	type?: 'button' | 'submit'
	children: ReactNode,
	disabled?: boolean
}
 
const getColorsByVariant = (variant?: ButtonVariants): {
	backGroundColor: string,
	fontColor: string,
	hoverBackground: string
} => {
	if (!variant) return {
		backGroundColor: colorPrimario,
		fontColor: 'white',
		hoverBackground: '#2d455e'
	}
	switch (variant) {
		case ButtonVariants.CONFIRM: return {
			backGroundColor: '#7dbd83',
			fontColor: 'white',
			hoverBackground: '#27541a',
		}
		case ButtonVariants.CANCEL: return {
			backGroundColor: '#d3d9e0',
			fontColor: 'white',
			hoverBackground: '#494c4f'
		}
		case ButtonVariants.DELETE: return {
			backGroundColor: '#bd827d',
			fontColor: 'white',
			hoverBackground: '#a31b0f'
		}
		case ButtonVariants.REGULAR: return {
			backGroundColor: colorPrimario,
			fontColor: 'white',
			hoverBackground: '#376e27'
		}
	}
}
 
export const SmartButton = ({onClick, children, type, variant, width, disabled}: GralButtonProps) => {
	const [isHover, setIsHover] = useState(false)
 
	const { backGroundColor, fontColor, hoverBackground } = getColorsByVariant(variant)
	const buttonStyles: CSSProperties = {
		padding: '12px 14px',
		margin: '0 4px',
		color: isHover ? 'white' : 'black',
		backgroundColor: isHover ? hoverBackground : backGroundColor,
		fontFamily: 'Raleway',
		fontWeight: 'bolder',
		borderRadius: '5px',
		cursor: 'pointer',
		width: width || 'auto'
	}
	 
	return (
		<button
			type={type || 'button'}
			style={buttonStyles}
			onClick={onClick}
			onMouseOver={() => setIsHover(true)}
			onMouseLeave={() => setIsHover(false)}
			disabled={disabled || false}
		>
			{children}
		</button>
	)
}
